import React, { useEffect, useState } from 'react';
import { datosEmpresa, datosEmpresaRequest, sitiosInteres } from '../../../../../../models/empresas/empresas.models';
import { guardarDatosEmpresa, obtenerListaEmpresasUsuario } from '../../../../../../actions/empresas/empresas.actions';
import { utilities } from '../../../../../../util/utilities';
import { Alerta } from '../../../../../../helpers/alerts/alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { EditarElementoModal } from '../../../../../modals/EditarElementoModal';
import { Modal } from '../../../../../modals/Modal';
import { url } from 'inspector';

export type DatosLaboralesFormProps = {
	onComplete: (estaCompleto: boolean) => void;
	idUsuarioElsa: number;
	accion: string;
}

interface formEmpresas {
	completado: boolean;
	datos: datosEmpresa;
}

const DatosLaboralesForm: React.FC<DatosLaboralesFormProps> = ({ onComplete, idUsuarioElsa, accion }) => {
	const [cargando, setCargando] = useState(false);
	const [mostrarCargando, setMostrarCargando] = useState(true);

	const [datosEmpresaForm, setDatosEmpresaForm] = useState<datosEmpresaRequest>({
		idUsuarioElsa: idUsuarioElsa,
		idEmpresaUsuario: 0,
		puesto: '',
		correo: '',
		direccionOficina: '',
		telefonoOficina: '',
		extension: '',
		sitiosInteres: []
	});
	const [listaEmpresas, setListaEmpresa] = useState<datosEmpresa[]>([]);

	const [formEmpresaSeleccionada, setFormEmpresaSeleccionada ] = useState<formEmpresas|null>(null);
	const [formEmpresa, setFormEmpresa] = useState<formEmpresas[]>([]);

	function handleInputSitioChange(name: string, value: string, indexEmpresa: number, indexSitio: number) {
		setFormEmpresa((prev: any) =>
			prev.map((empresa: formEmpresas, i: number) =>
				i === indexEmpresa
					? {
						...empresa,
						datos: {
							...empresa.datos,
							sitiosInteres: empresa.datos.sitiosInteres.map((sitio: any, j: number) =>
								j === indexSitio
									? { ...sitio, [name]: value }
									: sitio
							),
						},
					}
					: empresa
			)
		);
	}

	const handleInputChange = (name: string, value: string, index: number) => {
		if (name === "telefonoOficina" && value.length > 10) {
			return;
		}

		if (name === "extension" && value.length > 6) {
			return;
		}

		setFormEmpresa((prev) =>
			prev.map((item, i) =>
				i === index
					? {
						...item,
						datos: {
							...item.datos,
							[name]: value,
						},
					}
					: item
			)
		);
	}

	function agregarSitioInteres() {
		let longitudActualIndex: number = formEmpresaSeleccionada?.datos?.sitiosInteres?.length || 0;
		if(!formEmpresaSeleccionada?.datos?.idEmpresaUsuario) return
		let idEmpresaIndex: number = formEmpresaSeleccionada?.datos?.idEmpresaUsuario;
		let nuevoSitioInteres = {
			idSitio: 0,
			idEmpresaUsuario: idEmpresaIndex,
			titulo: "",
			borrado: false,
			existeEnRegistro: false,
			url: ""
		};

		setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, sitiosInteres: [ ...(formEmpresaSeleccionada?.datos?.sitiosInteres || []), nuevoSitioInteres ] } });

	}

	function removerSitioInteres( idSitio: number, index:number, existeEnRegistro: boolean) {
 
		let sitiosInteres: sitiosInteres[] = formEmpresaSeleccionada?.datos?.sitiosInteres || [];
		const listaSitiosInteresActualizada = sitiosInteres.map((sitio, i) =>sitio.idSitio === idSitio && index === i ? { ...sitio, borrado: true } : sitio);

		setFormEmpresaSeleccionada((item: any) =>{
			return {
				...item,
				datos: {
					...item.datos,
					sitiosInteres: [ ...listaSitiosInteresActualizada ]
				}
			}
		});
	}

	async function obtenerListaEmpresasUsuarioAsync() {
		try {
			const resp = await obtenerListaEmpresasUsuario(idUsuarioElsa);
			let listaEmpresas: datosEmpresa[] = resp.data;
			setListaEmpresa(listaEmpresas);
			const listaDatos: Array<formEmpresas> = listaEmpresas.map((datosEmpresa) => ({
					completado: datosEmpresa.datosCompletos,
					datos: datosEmpresa
				})
			);
			setFormEmpresa(listaDatos);
			setTimeout(() => {
				setMostrarCargando(false);
			}, 1500);
		} catch (err) {
			console.log("Error: " + err)
		}
	};

	function validarDatosFormulario(datosEmpresa: datosEmpresaRequest) {
		let esValido: boolean = true

		if (!datosEmpresa.correo.trim()) {
			esValido = false;
		}

		if (!datosEmpresa.puesto.trim()) {
			esValido = false;
		};

		if (!datosEmpresa.direccionOficina.trim()) {
			esValido = false;
		};

		if (!datosEmpresa.telefonoOficina.trim()) {
			esValido = false;
		}

		if (datosEmpresa.telefonoOficina.length < 10) {
			esValido = false;
		}

		if (datosEmpresa.sitiosInteres.length > 0) {
			datosEmpresa.sitiosInteres.map((sitio) => {
				if (sitio.titulo == "") {
					esValido = false;
				}

				if (sitio.url == "") {
					esValido = false;
				}
			})
		}

		return {
			esValido
		}
	}

	async function guardarDatosEmpresaAsync(dataForm: formEmpresas) {
		let datosFormulario: datosEmpresaRequest = {
			idEmpresaUsuario: dataForm.datos.idEmpresaUsuario,
			idUsuarioElsa: idUsuarioElsa,
			puesto: dataForm.datos.puesto,
			correo: dataForm.datos.correo,
			direccionOficina: dataForm.datos.direccionOficina,
			telefonoOficina: dataForm.datos.telefonoOficina,
			extension: dataForm.datos.extension,
			sitiosInteres: dataForm.datos.sitiosInteres.map(item=>({ ...item, existeEnRegistro: item.existeEnRegistro })) //Enviar solo los que ya existen en BD o los nuevos que no esten marcados como borrados
		};
		const { esValido } = validarDatosFormulario(datosFormulario);
		if (!esValido)  
			return;
		const response = await guardarDatosEmpresa(datosFormulario);
		setFormEmpresaSeleccionada(null);
		if (!response.success) {
			return Alerta(response.message, false);
		}	
		//const { data } = response;
		await obtenerListaEmpresasUsuarioAsync();
		Alerta(response.message, true);
		setFormEmpresaSeleccionada(null);
	}

	function editarDatosEmpresa(index: number) {
		setFormEmpresa((prev) =>
			prev.map((item, i) =>
				i === index
					? {
						...item,
						completado: false
					}
					: item
			)
		);
	}
	
	useEffect(() => {
		let completados = formEmpresa.filter(empresa => empresa.completado).length;
		if (completados == formEmpresa.length && formEmpresa.length > 0) {
			onComplete(accion == "editar" ? false : true);
		}
	}, [formEmpresa.filter(empresa => empresa.completado).length == formEmpresa.length])

	useEffect(() => {
		obtenerListaEmpresasUsuarioAsync();
	}, [])

	return (
		<div className='flex flex-col gap-5'>
			
			<div>
				{
					mostrarCargando ? (
						<div className='flex flex-col justify-center align-middle items-center p-5'>
							<span className="loading loading-spinner text-BlueDA loading-lg"></span>
						</div>
					) : (
						<div className='w-full'>
							<table className='table table-zebra border-DarkBlue table-md table-pin-rows table-pin-cols bg-white text-center'>
								<thead>
									<tr className='text-black'>
										<th>Empresa</th>
										<th>Puesto/Cargo</th>
										<th>Correo institucional</th>
										<th>Cantidad de sitios</th>
										<th>Acciones</th>
									</tr>
								</thead>
								<tbody>
									{
										formEmpresa.map((empresa, index) => (
											<tr key={`empresa-usuario-${index}-${empresa.datos.idEmpresa}`}>
												<td>
													{empresa?.datos?.razonSocialEmpresa}
												</td>
												<td>
													{empresa?.datos?.puesto || "No asignado"}
												</td>
												<td>
													{empresa?.datos?.correo || "No asignado"}
												</td>
												<td>
													{(empresa?.datos?.sitiosInteres || []).filter(item=>!item.borrado).length || "No asignados" }
												</td>
												<td className='flex flex-row gap-4 items-center justify-center text-base'>
													<button onClick={() => { setFormEmpresaSeleccionada(empresa)}}>
														<FontAwesomeIcon icon={faEdit} />
													</button>
												</td>
											</tr>
										))
									}
								</tbody>
							</table>
							
						</div>
					)
				}
			</div>
			
			<Modal 
				title='Información laboral' 
				open={(formEmpresaSeleccionada !== null)} 
				onClose={()=>{ setFormEmpresaSeleccionada(null) }} 
				actionContent={
					<div className='flex justify-end p-4'>
						<button
							className='btn btn-sm bg-BlueDAR'
							type='submit'
							form='form-empresausuario'
						>
							{
								cargando && (
									<div>
										<span className="loading loading-spinner loading-xs"></span>
									</div>
								)
							}
							<p className='text-white'>Guardar cambios</p>
						</button>
					</div>
				}
			>
				{
					formEmpresaSeleccionada !== null &&
					<form 
						id="form-empresausuario"
						className={"flex flex-col gap-4"} 
						onSubmit={(e)=>{
							e.preventDefault();
							//alert("prueba")
							guardarDatosEmpresaAsync(formEmpresaSeleccionada)
							
						}}
					>
						<div className='flex flex-col gap-5 rounded-xl border-slate-100 '>
							<div className='flex flex-row justify-between p-2 rounded-t-xl pl-4 pr-4 pt-4'>
								<p className='rounded-t-xl font-semibold'>Datos en la empresa</p>
								<div className='btn btn-sm btn-ghost' onClick={()=>{}}>
								</div>
							</div>
							<div className="grid grid-cols-2 justify-start gap-5 w-full pl-3 pr-3 pb-3">
								<div className='flex flex-col items-start w-full'>
									<label className='font-semibold'>Puesto/Cargo*</label>
									<input
										type="text"
										value={formEmpresaSeleccionada?.datos?.puesto ?? ""}
										onChange={(e) => setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, puesto: e.target.value }}) }
										placeholder={"Escriba el puesto/cargo"}
										className='input input-bordered w-full'
										required={true}
									/>
								</div>
								<div className='flex flex-col items-start w-full'>
									<label className='font-semibold'>Correo institucional*</label>
									<input
										type="email"
										value={formEmpresaSeleccionada?.datos?.correo ?? ""}
										onChange={(e) => setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, correo: e.target.value }}) }
										placeholder={"Escriba el correo institucional"}
										className='input input-bordered w-full'
										required={true}
									/>
								</div>
								<div className='flex flex-col items-start w-full'>
									<label className='font-semibold'>Dirección laboral*</label>
									<input
										type="text"
										value={formEmpresaSeleccionada?.datos?.direccionOficina ?? ""}
										onChange={(e) => setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, direccionOficina: e.target.value }}) }
										placeholder={"Escriba dirección laboral"}
										className='input input-bordered w-full'
										required={true}
									/>
								</div>
								<div className='flex flex-col items-start w-full'>
									<label className='font-semibold'>Número de teléfono*</label>
									<input
										type="number"
										value={formEmpresaSeleccionada?.datos?.telefonoOficina ?? ""}
										onChange={(e) => setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, telefonoOficina: e.target.value }}) }
										placeholder={"Escriba el número de teléfono laboral"}
										className='input input-bordered w-full'
										maxLength={10}
									/>
								</div>
								<div className='flex flex-col items-start w-full'>
									<label className='font-semibold'>Extensión</label>
									<input
										type="number"
										value={formEmpresaSeleccionada?.datos?.extension ?? ""}
										onChange={(e) => setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, extension: e.target.value }}) }
										placeholder={"Escriba la extensión"}
										className='input input-bordered w-full'
										maxLength={6}
									/>
								</div>
								
							</div>
						</div>
						<hr/>
						<div className='flex flex-col gap-2 rounded-xl border-slate-100 '>
							<div className='flex flex-row justify-between p-2 rounded-t-xl pl-4 pr-4 pt-4'>
								<p className='rounded-t-xl font-semibold'>Sitios de interés</p>
								<div className='btn btn-sm btn-ghost' onClick={() => {
									agregarSitioInteres()
								}}>
									<FontAwesomeIcon icon={faPlus} />
								</div>
							</div>
							{
								formEmpresaSeleccionada?.datos?.sitiosInteres?.length ?
								formEmpresaSeleccionada?.datos?.sitiosInteres.map((sitio, indexS) => {
									const tmpSitio = { ...sitio };
									if(sitio.borrado)
										return (
											<React.Fragment key={`sitios-interes-${indexS}-${sitio.idSitio}`}></React.Fragment>
										)
									return (
										<div key={`sitios-interes-${indexS}-${sitio.idSitio}`} className={`flex flex-col rounded-xl  border-slate-100 border-1`}>
											<div className='flex flex-row justify-between align-middle items-center pl-4 pr-4 pt-4'>
												<p>Sitio de interés</p>
												{
													<div  className="btn btn-sm  btn-ghost  right-2 top-2"  onClick={() => removerSitioInteres(tmpSitio.idSitio, indexS, tmpSitio.existeEnRegistro) }>
														<FontAwesomeIcon icon={faTrash} />
													</div>
												}
											</div>
											<div className='flex flex-col p-4 gap-5'>
												<div className='flex flex-col items-start w-full'>
													<label className='font-semibold'>Título*</label>
													<input
														type="text"
														value={tmpSitio.titulo ?? ""}
														onChange={(e) => {
															tmpSitio.titulo = e.target.value;
															setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, sitiosInteres: formEmpresaSeleccionada.datos.sitiosInteres.map((sitio, i) => i === indexS ? tmpSitio : sitio) } })
														}}
														placeholder={"Escriba el título"}
														className="input input-bordered w-full"
														required={true}
													/>
												</div>
												<div className='flex flex-col items-start w-full'>
													<label className='font-semibold'>URL*</label>
													<input
														type="url"
														value={tmpSitio.url ?? ""}
														onChange={(e) =>{ 
															tmpSitio.url = e.target.value;
															setFormEmpresaSeleccionada({ ...formEmpresaSeleccionada, datos: { ...formEmpresaSeleccionada.datos, sitiosInteres: formEmpresaSeleccionada.datos.sitiosInteres.map((sitio, i) => i === indexS ? tmpSitio : sitio) } })
														}}
														placeholder={"Escriba la URL"}
														className="input input-bordered w-full"
														required
													/>
												</div>
											</div>
										</div>
									)
								}) :
								<h1 className='font-semibold'>No hay sitios de interés asociados</h1>
							}
						</div>
						
					</form>
				}
			</Modal>
			
		</div >
	);
};

export default DatosLaboralesForm;
